
import { defineComponent, PropType } from "vue";

import { StaticPage } from "../data/types";
import common from "../styles/common.module.less";

export default defineComponent({
  name: "XiyouStaticArticle",
  props: {
    page: { type: Object as PropType<StaticPage>, required: true },
  },
  setup(props) {
    return () => (
      <article class={common.article}>
        <h1 class={common.pageTitle}>{props.page.title}</h1>
        <p class={common.pageSubtitle}>{props.page.subtitle}</p>
        <nav class={common.articleNav}>
          {props.page.sections.map((section) => (
            <a
              key={section.heading}
              class={common.articleNavItem}
              href={`#${props.page.slug}-${section.heading}`}
            >
              {section.heading}
            </a>
          ))}
        </nav>
        {props.page.sections.map((section) => (
          <section
            key={section.heading}
            class={common.articleSection}
            id={`${props.page.slug}-${section.heading}`}
          >
            <h2 class={common.articleHeading}>{section.heading}</h2>
            <div class={[common.articleBody, common.prose]}>
              {section.paragraphs.map((text) => (
                <p key={text}>{text}</p>
              ))}
            </div>
          </section>
        ))}
      </article>
    );
  },
});
